import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('thru_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config.url.includes('/auth/login')) {
      localStorage.removeItem('thru_token');
      localStorage.removeItem('thru_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;

// Auth
export const login = (email, password) =>
  api.post('/api/auth/login', { username: email, password });
export const register = (data) => api.post('/api/auth/register', data);
export const getMe = () => api.get('/api/auth/me');
export const changePassword = (data) => api.post('/api/auth/change-password', data);

// Dashboard
export const getDashboard = () => api.get('/api/dashboard');

// Fellows
export const getFellows = (params) => api.get('/api/fellows', { params });
export const getFellow = (id) => api.get(`/api/fellows/${id}`);
export const updateProfile = (id, data) => api.put(`/api/fellows/${id}`, data);
export const uploadAvatar = (id, file) => {
  const fd = new FormData(); fd.append('file', file);
  return api.post(`/api/fellows/${id}/avatar`, fd);
};

// Presentations
export const getPresentations = (params) => api.get('/api/presentations', { params });
export const createPresentation = (data) => api.post('/api/presentations', data);
export const updatePresentation = (id, data) => api.put(`/api/presentations/${id}`, data);
export const deletePresentation = (id) => api.delete(`/api/presentations/${id}`);
export const uploadSlides = (id, file) => {
  const fd = new FormData(); fd.append('file', file);
  return api.post(`/api/presentations/${id}/slides`, fd);
};

// Meetings
export const getMeetings = (params) => api.get('/api/meetings', { params });
export const createMeeting = (data) => api.post('/api/meetings', data);
export const updateMeeting = (id, data) => api.put(`/api/meetings/${id}`, data);
export const deleteMeeting = (id) => api.delete(`/api/meetings/${id}`);

// Announcements
export const getAnnouncements = (params) => api.get('/api/announcements', { params });
export const createAnnouncement = (data) => api.post('/api/announcements', data);
export const updateAnnouncement = (id, data) => api.put(`/api/announcements/${id}`, data);
export const deleteAnnouncement = (id) => api.delete(`/api/announcements/${id}`);

// Resources
export const getResources = (params) => api.get('/api/resources', { params });
export const getResourceCategories = () => api.get('/api/resources/categories');
export const createResource = (formData) => api.post('/api/resources', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteResource = (id) => api.delete(`/api/resources/${id}`);

// Tasks
export const getTasks = (params) => api.get('/api/tasks', { params });
export const createTask = (data) => api.post('/api/tasks', data);
export const updateTask = (id, data) => api.put(`/api/tasks/${id}`, data);
export const deleteTask = (id) => api.delete(`/api/tasks/${id}`);

// Calendar
export const getCalendarEvents = (params) => api.get('/api/calendar', { params });
export const createCalendarEvent = (data) => api.post('/api/calendar', data);
export const deleteCalendarEvent = (id) => api.delete(`/api/calendar/${id}`);

// Notifications
export const getNotifications = (params) => api.get('/api/notifications', { params });
export const markAllRead = () => api.post('/api/notifications/mark-all-read');

// Polls
export const getPolls = () => api.get('/api/polls');
export const createPoll = (data) => api.post('/api/polls', data);
export const votePoll = (id, option_id) => api.post(`/api/polls/${id}/vote`, { option_id });
export const removeVote = (id) => api.delete(`/api/polls/${id}/vote`);
export const updatePoll = (id, data) => api.put(`/api/polls/${id}`, data);
export const deletePoll = (id) => api.delete(`/api/polls/${id}`);

// Admin
export const getAdminUsers = () => api.get('/api/admin/users');
export const updateAdminUser = (id, data) => api.put(`/api/admin/users/${id}`, data);
export const deleteAdminUser = (id) => api.delete(`/api/admin/users/${id}`);
export const getAnalytics = () => api.get('/api/admin/analytics');
export const getAdminActivity = () => api.get('/api/admin/activity');
export const assignSupervisor = (data) => api.post('/api/admin/assign-supervisor', data);

// Supervisor
export const getSupervisorFellows = () => api.get('/api/supervisor/fellows');
